import { render, staticRenderFns } from "./addNotice.vue?vue&type=template&id=6f9d0a22&scoped=true&"
import script from "./addNotice.vue?vue&type=script&lang=js&"
export * from "./addNotice.vue?vue&type=script&lang=js&"
import style0 from "./addNotice.vue?vue&type=style&index=0&id=6f9d0a22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9d0a22",
  null
  
)

export default component.exports